
const BASE_URL = 'https://artis-web-api-2w5h1cme.ew.gateway.dev/apigateway/'

export const environment = {
  // App name
  appName: 'ARTIS Development',

  // Cloud function strings
  googleCloudRun: {
    newContactSubmission: BASE_URL+'newContactSubmission'
  },
  
  // Firebase app configuration
  firebaseConfig : {
    apiKey: "AIzaSyByyuRa9SQq8Bg9g2JZ-o5d0IWVluCG5JQ",
    authDomain: "artis-web-dev.firebaseapp.com",
    projectId: "artis-web-dev",
    storageBucket: "artis-web-dev.appspot.com",
    messagingSenderId: "226716310310",
    appId: "1:226716310310:web:a538dad672aefd5d12bfe7",
    measurementId: "G-6G723FS0B3"
  },

  // Meta information
  metaInformation: {
    es: {
      "description": "",
      "keywords": "",
      "og:title": "",
      "og:description": "",
      "og:image": "",
      "og:image:type": "",
      "og:image:width": "",
      "og:image:height": "",
      "og:image:alt": "",
      "og:url": "",
      "og:type": "",
    },
    en: {
      "description": "",
      "keywords": "",
      "og:title": "",
      "og:description": "",
      "og:image": "g",
      "og:image:type": "",
      "og:image:width": "",
      "og:image:height": "",
      "og:image:alt": "",
      "og:url": "",
      "og:type": "",
    },
  },

  production: false
};
